import React, { useState } from 'react';

const TOOLS = [
  { name: 'Hammer', img: 'https://cdn-icons-png.flaticon.com/512/272/272684.png' },
  { name: 'Wrench', img: 'https://cdn-icons-png.flaticon.com/512/272/272688.png' },
  { name: 'Screwdriver', img: 'https://cdn-icons-png.flaticon.com/512/272/272691.png' },
];

function shuffle(arr) {
  return arr.map(a => [a, Math.random()]).sort((a, b) => a[1] - b[1]).map(a => a[0]);
}

function ToolDragDrop({ onComplete, xpReward = 20, coinReward = 5 }) {
  const [toolOrder] = useState(shuffle(TOOLS));
  const [matches, setMatches] = useState({}); // { name: img }
  const [dragged, setDragged] = useState(null);
  const [solved, setSolved] = useState(false);

  const handleDragStart = (img) => setDragged(img);
  const handleDrop = (name) => {
    if (!dragged) return;
    setMatches(m => ({ ...m, [name]: dragged }));
    setDragged(null);
  };
  const handleDragOver = e => e.preventDefault();

  const allCorrect = TOOLS.every(t => matches[t.name] === t.img);

  const handleCheck = () => {
    if (allCorrect) {
      setSolved(true);
      setTimeout(() => onComplete({ xp: xpReward * TOOLS.length + 30, coins: coinReward }), 1200);
    }
  };

  return (
    <div style={{ padding: 16, textAlign: 'center', minWidth: 280, maxWidth: 400 }}>
      <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 12 }}>Tool Identification</h3>
      <div style={{ color: '#555', marginBottom: 18 }}>Drag each tool image to its correct name.</div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginBottom: 18 }}>
        {/* Images */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {toolOrder.map(tool => (
            <img
              key={tool.img}
              src={tool.img}
              alt={tool.name}
              draggable
              onDragStart={() => handleDragStart(tool.img)}
              style={{ width: 54, height: 54, borderRadius: 10, border: '2px solid #e5e7eb', background: '#f8fafc', boxShadow: '0 2px 8px rgba(34,197,94,0.07)', opacity: Object.values(matches).includes(tool.img) ? 0.4 : 1, cursor: 'grab', transition: 'opacity 0.2s' }}
            />
          ))}
        </div>
        {/* Name boxes */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {TOOLS.map(tool => {
            const matched = matches[tool.name];
            const correct = matched === tool.img;
            return (
              <div
                key={tool.name}
                onDrop={() => handleDrop(tool.name)}
                onDragOver={handleDragOver}
                style={{
                  width: 120,
                  height: 54,
                  border: `2px solid ${matched ? (correct ? '#22c55e' : '#ef4444') : '#e5e7eb'}`,
                  borderRadius: 10,
                  background: matched ? (correct ? '#bbf7d0' : '#fecaca') : '#f8fafc',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 600, fontSize: 17, color: '#222',
                  boxShadow: '0 2px 8px rgba(34,197,94,0.07)',
                  transition: 'all 0.2s',
                }}
              >
                {tool.name}
                {matched && correct && <span style={{ marginLeft: 8, color: '#22c55e', fontWeight: 700 }}>✅</span>}
                {matched && !correct && <span style={{ marginLeft: 8, color: '#ef4444', fontWeight: 700 }}>❌</span>}
              </div>
            );
          })}
        </div>
      </div>
      <button className="gogig-card-btn" style={{ width: 180 }} onClick={handleCheck} disabled={solved || !allCorrect}>{solved ? 'Solved!' : 'Check'}</button>
      {solved && <div style={{ color: '#22c55e', fontWeight: 700, marginTop: 12 }}>Great job! You earned {xpReward * TOOLS.length + 30} XP and {coinReward} Coins!</div>}
    </div>
  );
}

export default ToolDragDrop; 